"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var RadixCheckbox = __importStar(require("@radix-ui/react-checkbox"));
var react_icons_1 = require("@radix-ui/react-icons");
var react_1 = require("@stitches/react");
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var StyledCheckbox = (0, react_1.styled)(RadixCheckbox.Root, {
    height: "13px",
    width: "13px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: stitches_config_1.theme.colors.white,
    borderRadius: "4px",
    borderStyle: "solid",
    borderWidth: "1.25px",
    padding: "1.5px 2px",
    borderColor: stitches_config_1.theme.colors.gray9,
    "&:hover": {
        background: stitches_config_1.theme.colors.gray2,
        borderColor: stitches_config_1.theme.colors.gray10,
    },
    "&[data-state='checked']": {
        background: stitches_config_1.theme.colors.blue9,
        borderColor: stitches_config_1.theme.colors.blue10,
        "&:hover": {
            background: stitches_config_1.theme.colors.blue10,
            borderColor: stitches_config_1.theme.colors.blue10,
        },
    },
    "&[data-state='indeterminate']": {
        background: stitches_config_1.theme.colors.blue9,
        borderColor: stitches_config_1.theme.colors.blue10,
        "&:hover": {
            background: stitches_config_1.theme.colors.blue10,
            borderColor: stitches_config_1.theme.colors.blue10,
        },
    },
    "&[data-disabled]": {
        opacity: 0.5,
        cursor: "not-allowed",
    },
});
var CheckboxWrapper = (0, react_1.styled)("div", {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "0px 1.5px",
    gap: "8px",
    variants: {
        disabled: {
            true: {
                opacity: 0.5,
                cursor: "not-allowed",
            },
        },
    },
});
var StyledCheckboxIndicator = (0, react_1.styled)(RadixCheckbox.Indicator, {
    display: "flex",
    alignItems: "center",
});
var StyledCheckIcon = (0, react_1.styled)(react_icons_1.CheckIcon, {
    color: stitches_config_1.theme.colors.white,
});
var StyledDashIcon = (0, react_1.styled)(react_icons_1.DashIcon, {
    color: stitches_config_1.theme.colors.white,
});
function Checkbox(props) {
    return ((0, jsx_runtime_1.jsxs)(CheckboxWrapper, __assign({ disabled: props.disabled }, { children: [(0, jsx_runtime_1.jsx)(StyledCheckbox, __assign({ disabled: props.disabled, checked: props.checked, onCheckedChange: props.onCheckedChange }, { children: (0, jsx_runtime_1.jsx)(StyledCheckboxIndicator, { children: props.checked === "indeterminate" ? ((0, jsx_runtime_1.jsx)(StyledDashIcon, {})) : ((0, jsx_runtime_1.jsx)(StyledCheckIcon, {})) }) })), typeof props.label === "string" ? ((0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-sm-plus" }, { children: props.label }))) : (props.label)] })));
}
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map